/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MarketplaceSettingsResult = {
  /**
   * The default marketplace name used when no override is configured.
   */
  defaultName: string;
  /**
   * The marketplace name that will be used at publish time (override if set, otherwise default).
   */
  effectiveName: string;
  /**
   * User-provided override for the marketplace name. Absent when no override is configured.
   */
  marketplaceName?: string | undefined;
  /**
   * Whether this project's observability plugin is included in the published marketplace and installed by the device agent. Defaults to true when unset.
   */
  observabilityEnabled: boolean;
};

/** @internal */
export const MarketplaceSettingsResult$inboundSchema: z.ZodMiniType<
  MarketplaceSettingsResult,
  unknown
> = z.pipe(
  z.object({
    default_name: z.string(),
    effective_name: z.string(),
    marketplace_name: z.optional(z.string()),
    observability_enabled: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "default_name": "defaultName",
      "effective_name": "effectiveName",
      "marketplace_name": "marketplaceName",
      "observability_enabled": "observabilityEnabled",
    });
  }),
);

export function marketplaceSettingsResultFromJSON(
  jsonString: string,
): SafeParseResult<MarketplaceSettingsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MarketplaceSettingsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MarketplaceSettingsResult' from JSON`,
  );
}
